export default __webpack_public_path__ + "static/25-76cb6d4f67a08a4890a92d150794b48c.png";